"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ApiProvider = void 0;
var _auth = require("@ori/auth");
var _configurationManager = require("@ori/configuration-manager");
var _environment = require("@ori/environment");
var _fetching = require("@ori/fetching");
var _globalApiClientReact = require("@ori/global-api-client-react");
var _i18n = require("@ori/i18n");
var _mobileOfficeApiClientReact = require("@ori/mobile-office-api-client-react");
var _jsxRuntime = require("react/jsx-runtime");
const TIMEOUT_IN_MS = 10_000;
const swrConfig = {
  errorRetryCount: 3,
  errorRetryInterval: 10000,
  focusThrottleInterval: 300000,
  shouldRetryOnError: true,
  suspense: true
};
const ApiProvider = ({
  children
}) => {
  const {
    formattedToken
  } = (0, _auth.useToken)();
  const {
    language
  } = (0, _i18n.useLanguage)();
  const {
    tenant
  } = (0, _environment.useEnvironment)();
  const {
    mobileOfficeApiUrl,
    globalApiUrl
  } = (0, _configurationManager.useServiceUrls)(['mobileOfficeApi', 'globalApi']);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_fetching.SWRConfig, {
    value: swrConfig,
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_mobileOfficeApiClientReact.ApiClientProvider, {
      baseUrl: mobileOfficeApiUrl,
      language: language,
      tenant: tenant,
      token: formattedToken,
      timeout: TIMEOUT_IN_MS,
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_globalApiClientReact.ApiClientProvider, {
        baseUrl: globalApiUrl,
        language: language,
        tenant: tenant,
        token: formattedToken,
        timeout: TIMEOUT_IN_MS,
        children: children
      })
    })
  });
};
exports.ApiProvider = ApiProvider;